// extracted by mini-css-extract-plugin
export var textBlock = "textBlock-module--textBlock--1lcFr";